import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

// Compteur global : évite les collisions d'ID quand plusieurs blocs collapse
// sont présents sur la même page (loop.index Twig repart de 1 à chaque bloc)
let collapseUid = 0;

export default class BlockCollapse {

	constructor() {
		//this.containers = document.querySelectorAll(".collapses-container");
		this.collapses = document.querySelectorAll(".collapses-container .collapse");
		this.build();
		GlobalVariables.resizeCallbacks.push(this);
	}

	build() {
		this.collapses.forEach(collapse => {
			const head = collapse.querySelector(".collapse-head");
			const body = collapse.querySelector(".collapse-body");

			// Réattribue des IDs uniques et met à jour les références ARIA
			const uid = collapseUid++;
			head.id = `collapse-head-${uid}`;
			body.id = `collapse-body-${uid}`;
			head.setAttribute("aria-controls", body.id);
			body.setAttribute("aria-labelledby", head.id);
			const container = collapse.closest(".collapses-container");
			const block = collapse.closest(".block");

			const dispatchCollapseChange = () => {
				if (!block) {
					return;
				}

				block.dispatchEvent(new CustomEvent("collapse:change", {
					detail: {
						id: collapse.dataset.id,
						collapse,
						container
					}
				}));
			};

			body.style.height = "auto";
			body.dataset.height = body.clientHeight;

			if (collapse.classList.contains("open")) {
				body.style.height = `${body.dataset.height}px`;
				body.removeAttribute("inert");
				head.setAttribute("aria-expanded", "true");
				dispatchCollapseChange();
			} else {
				body.style.height = 0;
			}

			head.addEventListener("click", () => {
				if (collapse.classList.contains("open")) {
					if (container.classList.contains("always-open")) {
						return;
					} else {
						collapse.classList.remove("open");
						head.setAttribute("aria-expanded", "false");
						body.setAttribute("inert", "");
						if (GlobalVariables.reducedMotion) {
							body.style.height = 0;
						} else {
							gsap.to(body, { height: 0, duration: 0.3 });
						}
					}
				} else {
					container.querySelectorAll(".collapse").forEach(otherCollapse => {
						if (otherCollapse !== collapse && otherCollapse.classList.contains("open")) {
							const otherBody = otherCollapse.querySelector(".collapse-body");
							const otherHead = otherCollapse.querySelector(".collapse-head");
							otherCollapse.classList.remove("open");
							otherHead.setAttribute("aria-expanded", "false");
							otherBody.setAttribute("inert", "");
							if (GlobalVariables.reducedMotion) {
								otherBody.style.height = 0;
							} else {
								gsap.to(otherBody, { height: 0, duration: 0.3 });
							}
						}
					});

					body.style.height = "auto";
					body.dataset.height = body.clientHeight;
					body.style.height = 0;

					collapse.classList.add("open");
					head.setAttribute("aria-expanded", "true");
					body.removeAttribute("inert");
					dispatchCollapseChange();
					if (GlobalVariables.reducedMotion) {
						body.style.height = "auto";
					} else {
						gsap.to(body, {
							height: body.dataset.height,
							duration: 0.3,
							onComplete: () => { body.style.height = "auto"; }
						});
					}
				}
			});
		});
	}


	resize() {
		this.collapses.forEach(collapse => {
			const body = collapse.querySelector(".collapse-body");
			body.style.height = "auto";
			body.dataset.height = body.clientHeight;
			if (collapse.classList.contains("open")) {
				body.style.height = "auto";
			} else {
				body.style.height = 0;
			}
		});
	}
}
